import React, { useMemo } from "react";
import Loader from "../../../components/Loader";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";
import {
  extractDateFromStr,
  getLatestUpdatedObject,
  groupVideosByCategory,
} from "../../../Utils/utils";
import { useSelector } from "react-redux";
import VideoCard from "../../../components/VideoCard";

const VideoGalleryCSR = () => {
  const { languageType } = useSelector((state) => state.homeSlice);

  const { data: videosGalleryData = [], isLoading: videosGalleryIsLoading } =
    useGetProtectedApiDataQuery({
      url: "csr_video_gallery",
      lang: languageType,
    });
  const { getText } = useLanguageTranslation();

  const transformedVideoData = groupVideosByCategory(videosGalleryData);

  const lastUpdatedOn = useMemo(() => {
    return extractDateFromStr(
      getLatestUpdatedObject(videosGalleryData)?.changed
    );
  }, [videosGalleryData]);

  if (videosGalleryIsLoading) {
    return (
      <div className="csr-loader">
        <Loader />;
      </div>
    );
  }

  return (
    <>
      <div className="container">
        <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
        <h2 className="title2">{getText("Video Gallery", "वीडियो गैलरी")}</h2>

        {transformedVideoData.map((video, index) => (
          <div className="row" key={index}>
            <div className="inner-video-tiitle">{video.category}</div>
            {video.data.length > 0 ? (
              video.data.map((item, i) => (
                <div
                  className="col-12 col-sm-12 col-md-4 col-lg-4 mvDescWrap mb-4"
                  key={i}
                >
                  <VideoCard item={item} />
                </div>
              ))
            ) : (
              <h2 className="title4">
                {getText("No Video available", "कोई वीडियो उपलब्ध नहीं")}
              </h2>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default VideoGalleryCSR;
